module.exports = __webpack_public_path__ + "7d9b818941d1266fe0f61f1d3609e0b4.png";